import styled from 'styled-components';
import React from 'react';
import { MobileScreen } from '../../styles/ConstantMediaQuery';
import ColorConstants from '../../../constants/ColorConstants';

export const RoundedInput = styled.input`
    align-items: center;
    border-radius:40px;
    border: 1px solid ${ColorConstants['titan-white']};
    color: ${ColorConstants.manatee};
    display: flex;
    font-size: 16px;
    height: 32px;
    justify-content: center;
    overflow: auto;
    resize: none;
    width: 215px;
    margin-right: 15px;
    padding: 0 15px;
    font-weight: regular;
    
    &:focus {
        outline: none;
    }

    &:focus::placeholder {
        color:transparent;
    };

    &::placeholder {
        color: ${ColorConstants['regal-blue-50%']};
        content: attr(placeholder);
        cursor: text;
        display: flex;
        font-size: 16px;
        font-weight: 400;
    };

    @media ${MobileScreen} {
        margin: 0 10px 0 0;
        width: 100%;
        margin-right: 0px;
    }
`;

export const RoundedInputWithMagnifier = styled(RoundedInput)`
    background: url(/static/img/svg/magnifier.svg) no-repeat scroll;
    background-size: 15px;
    background-position: 95% 50%;
    height: 43px;
`;
export const StyledRoundedInput = styled(RoundedInputWithMagnifier)`
    width: 100%;
`;

const Wrapper = styled.div`
    width: 100%;
    padding: 0px 16px;
`;

export const SelectorInputWithMagnifier = props => (
    <Wrapper>
        <StyledRoundedInput {...props} />
    </Wrapper>
);
